"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildEventPayload = exports.eventToEventBody = void 0;
__exportStar(require("./meta"), exports);
__exportStar(require("./actions"), exports);
const eventToEventBody = (ev) => {
    const eventBody = {
        action: ev.action,
        meta: ev.meta,
        organization_id: ev.organizationId,
        timestamp: ev.timestamp,
        unique_id: ev.uniqueId,
        identity: ev.identity,
        referrer_url: ev.referrerUrl,
        experiment_id: ev.experimentId,
        variant_key_name: ev.variantKeyName,
        page_id: ev.pageId,
        session_id: ev.sessionId,
        experiment_features: ev.experimentFeatures,
        url: ev.url,
        user_agent: ev.userAgent,
        client_id: ev.clientId,
        lead_id: ev.leadId,
        email: ev.email,
        user_id: ev.userId,
        event_source: ev.eventSource,
        client_submission_unique_id: ev.clientSubmissionUniqueId,
        cookies: ev.cookies,
        raw_cookies: ev.rawCookies,
        tracking_status: ev.trackingStatus,
        tracking_transport: ev.trackingTransport,
        page_height_pixels: ev.pageHeightPixels,
        page_width_pixels: ev.pageWidthPixels,
        page_scroll_depth: ev.pageScrollDepth,
        browser_locale: ev.browserLocale,
        client_library_version: ev.clientLibraryVersion,
        timezone_offset_hours: ev.timezoneOffsetHours,
        timezone: ev.timezone,
        is_test: ev.isTest,
        cohort_id: ev.cohortId,
        feature_flags: ev.featureFlags,
        decision_id: ev.decisionId,
        client_side_decision_id: ev.clientSideDecisionId,
    };
    return eventBody;
};
exports.eventToEventBody = eventToEventBody;
const buildEventPayload = (ev, sender, uniqueId) => ({
    uniqueId,
    sender,
    action: 'event.track',
    data: (0, exports.eventToEventBody)(ev),
});
exports.buildEventPayload = buildEventPayload;
